import { render, staticRenderFns } from "./Step1Cliente.vue?vue&type=template&id=fcb99e0e&scoped=true&lang=pug"
import script from "./Step1Cliente.vue?vue&type=script&lang=js"
export * from "./Step1Cliente.vue?vue&type=script&lang=js"
import style0 from "./Step1Cliente.vue?vue&type=style&index=0&id=fcb99e0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb99e0e",
  null
  
)

export default component.exports